<div class="modal fade in" tabindex="-1" role="dialog" aria-labelledby="TitleLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="TitleLabel" style="margin-bottom:0;">
          {{title}}
        </h2>
        <a class="btn btn-close" aria-label="Close" (click)="_cancel()"></a>
      </div>

      <div class="modal-body" style="overflow-y: auto;">
        @if (fileType == 'files') {
          <div class="list-group list-group-flush">
            @for (file of fileReferences; track file; let i = $index) {
              <div
                class="d-flex align-items-center justify-content-center file-hover list-group-item" (click)="openFile(file)">
                <span class="px-3 me-auto text-truncate ">
                  {{ file.filename }}
                </span>
              </div>
            }
          </div>
        }

        @if (fileType == 'images') {
          <div class="d-flex gap-1 flex-wrap">
            @for (img of fileReferences; track img; let i = $index) {
              <div class="d-flex">
                <img [id]='"img" + assetFieldValue.id.toString() + i.toString()'
                  [src]="fileURLMap[img?.id] | async" alt="" class="m-3 card" style="max-height: 100px; cursor:pointer;"
                  (click)="openImageInNewTab(img)">
                </div>
              }
            </div>
          }
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="_cancel()">{{cancelText}}</button>
        </div>
      </div>
    </div>
  </div>